import { Alert, AppBar, Box, Container, IconButton, Toolbar, Typography } from "@mui/material";
import {
    Add as AddIcon,
    Code as CodeIcon,
    Logout as LogoutIcon,
    Search as SearchIcon,
    Assignment as AssignmentIcon,
    Home as HomeIcon
  } from '@mui/icons-material';
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";
import TryCodingPanel from "./TryCodingPanel";

export default function CustomAppBar({ children }) {
    const { user, logout } = useAuth();
    const [tryCodingOpen, setTryCodingOpen] = useState(false);

    const handleLogout = () => {
        logout();
      };

    const goHome = () => {
        window.location.href = '/subjects';
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
            <AppBar position="static" elevation={0} sx={{ borderRadius: 0 }}>
                <Toolbar sx={{ px: { xs: 2, md: 4 } }}>
                    <Box 
                        onClick={goHome}
                        sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, cursor: 'pointer' }}
                    >
                        <CodeIcon sx={{ mr: 2, fontSize: 28 }} />
                        <Typography variant="h5" component="div" sx={{ fontWeight: 700, letterSpacing: '-0.5px' }}>
                            The Revision App
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1, bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 2, display: { xs: 'none', sm: 'flex' } }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                Welcome, {user?.username}!
                            </Typography>
                        </Box>
                        <IconButton
                            color="inherit"
                            onClick={goHome}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
                            }}
                            title="Home"
                        >
                            <HomeIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={() => window.location.href = '/tests'}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
                            }}
                            title="Test History"
                        >
                            <AssignmentIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={() => setTryCodingOpen(true)}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
                            }}
                            title="Try Coding"
                        >
                            <CodeIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={handleLogout}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
                            }}
                        >
                            <LogoutIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <Container maxWidth="xl" sx={{ flexGrow: 1, py: 4, px: { xs: 2, md: 4 } }}>
                {children}
            </Container>

            {/* Try Coding Panel */}
            <TryCodingPanel
                open={tryCodingOpen}
                onClose={() => setTryCodingOpen(false)}
            />
        </Box>
    )
}